import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    archiveQuote: 'Mark as declined',
    convertQuoteToInvoice: 'Turn into invoice',
    delete: 'Delete',
    duplicate: 'Duplicate',
    edit: 'Edit',
    markQuoteAsAccepted: 'Mark as approved',
    markQuoteAsSent: 'Mark as sent',
    resend: 'Resend',
    reviseQuote: 'Correct the quote',
    seeInvoice: 'See invoice',
  },
  fr: {
    archiveQuote: 'Marquer comme refusé',
    convertQuoteToInvoice: 'Transformer en facture',
    delete: 'Supprimer',
    duplicate: 'Dupliquer',
    edit: 'Modifier',
    markQuoteAsAccepted: 'Marquer comme accepté',
    markQuoteAsSent: 'Marquer comme envoyé',
    resend: 'Renvoyer',
    reviseQuote: 'Corriger le devis',
    seeInvoice: 'Voir la facture',
  },
} as const);

export default locales;
